// extracted by mini-css-extract-plugin
export default {"cellWrapper":"OrchestrationNameCell_cellWrapper__4EAMC","cellText":"OrchestrationNameCell_cellText__I0QaQ"};